/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * What kind of customer a company is, set by OneFront admin. Separate from the computed
 * SubscriptionStatus, which says where the company is in its renewal cycle.
 * @export
 */
export const WebApiModelsEnumerationTypesAccountType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesAccountType = typeof WebApiModelsEnumerationTypesAccountType[keyof typeof WebApiModelsEnumerationTypesAccountType];


export function WebApiModelsEnumerationTypesAccountTypeFromJSON(json: any): WebApiModelsEnumerationTypesAccountType {
    return WebApiModelsEnumerationTypesAccountTypeFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesAccountTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesAccountType {
    return json as WebApiModelsEnumerationTypesAccountType;
}

export function WebApiModelsEnumerationTypesAccountTypeToJSON(value?: WebApiModelsEnumerationTypesAccountType | null): any {
    return value as any;
}

